import { render, staticRenderFns } from "./PieChartSimple.vue?vue&type=template&id=4d4ec91a&"
import script from "./PieChartSimple.vue?vue&type=script&lang=js&"
export * from "./PieChartSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports